import React,{useRef,useState } from 'react'
import { MainContainer, FormContainer, InputContainer } from "./signup/SignupElements"
import { auth } from "../firebase"
import { useHistory } from 'react-router'

function ResetPassword() {
    const emailRef = useRef()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history=useHistory()
    
    const handleSubmit = () => {
        if (emailRef !== "") {
            auth.sendPasswordResetEmail(emailRef).then(() => {
                setLoading(true)
                setError("An email has been sent to you.")
             }).catch((error) => {
                 console.log(error)
                 setError("Something is not right here")
             })
        }
        else {
            setError("Please fill in the email bar!!")
        }
    }
    const handleSubmit2 = () => {
        auth.signOut().then(() => {
            history.push("/")
        }).catch((error) => {
            console.log(error)
        })
    }
    return (
        <MainContainer>
            <div >
                <button className="signOutButton" onClick={ handleSubmit2}>Sign Out</button>
            </div>
            <h2>Reset your password.</h2>
            <p style={{color:"black"}}>{ error}</p>
            <FormContainer >
                <InputContainer>
                    <label>Enter Your Email:</label>
                    <input type="email" ref={ emailRef} required/>
                </InputContainer>
                <button type="submit" disabled={ loading} onClick={ handleSubmit}>Reset Password</button>
            </FormContainer>
            
        </MainContainer>
    )
}

export default ResetPassword
